// extracted by mini-css-extract-plugin
module.exports = {"section":"H_section__fgD1R"};